export const DEFAULT_ACTION = 'screen/ProfileScreen/DEFAULT_ACTION';
export const UPDATE_INPUT = 'screen/ProfileScreen/UPDATE_INPUT';

export const GET_PEGAWAI = 'screen/ProfileScreen/GET_PEGAWAI';
export const GET_PEGAWAI_LOADING = 'screen/ProfileScreen/GET_PEGAWAI_LOADING';
export const GET_PEGAWAI_SUCCESS = 'screen/ProfileScreen/GET_PEGAWAI_SUCCESS';
export const GET_PEGAWAI_FAIL = 'screen/ProfileScreen/GET_PEGAWAI_FAIL';